import Logger from "../core/util/Logger";

export const userLogoutAction = () => async dispatch => {
    Logger.info("user sign out");
    dispatch({type: "USER_LOGOUT", payload: {message: 'You have successfully logged out!'}});
};